<template>
  <div>
    <home-header></home-header>
    <div class="tip">
      {{tipStr}}
    </div>
  </div>
</template>

<script>
    import HomeHeader from '@/components/home/components/header/header';
    export default {
      data(){
        return{
          tipStr: '系统跳转中，请稍后...',
          keyJson: ''
        }
      },
      components: {
        HomeHeader
      },
      created: function() {
        this.keyJson = this.$route.params.keyJson;
        var keyValue = this.keyJson;
        if (keyValue!='') {
          this.systemKeyLogin(keyValue);
        }
      },
      methods:{
        systemKeyLogin(keyValue) {
          var v = this;
          // 根据key调用接口
          $.ajax({
              type:'get',
              url: v.userApi+"api/Account/SystemKeyLogin",
              data: {
                'key': keyValue,
                'systemId': v.subsystemId
              },
              dataType:'json',
              success:function(des){
                // 重置sessionStorage数据
                sessionStorage.clear();

                var data = JSON.parse(des);
                sessionStorage.setItem('drainage-userInfo', data.userInfo);
                sessionStorage.setItem('drainage-companyInfo', data.companyInfo);
                sessionStorage.setItem('drainage-groupInfo', data.groupInfo);
                sessionStorage.setItem('drainage-moduleInfo', data.moduleInfo);

                v.$router.push({
                  name: 'Message'
                });
              },
              error: function(err) {
                v.tipStr = '跳转提示信息：'+err.responseJSON.Message+'错误代码：'+err.status;
              }
          })         
        }
      }
    }
</script>

<style >
  .tip {
    margin: 0px 22%;
    padding-top: 8%;
    font-size: 18px;
    font-family: Microsoft YaHei;
  }
</style>



// WEBPACK FOOTER //
// src/common/systemTurn.vue